<script setup>
import { onMounted } from "vue";
import { useShepherd } from "vue-shepherd";
import { useStorage } from "@vueuse/core";

const tourVersionSeen = useStorage("tourVersionSeen", 0);
const currentTourVersion = 20230417;
const tour = useShepherd({
  useModalOverlay: true,
}).on("complete", () => {
  tourVersionSeen.value = currentTourVersion;
});

const startTour = function startTour() {
  tour.addStep({
    id: "step-1",
    text: "Click a color / feeling to navigate into the music library",
    classes: "text-center",
    modalOverlayOpeningPadding: -35,
    modalOverlayOpeningRadius: 10,
    attachTo: {
      element: ".wheel-feeling-arc.love",
      on: "bottom",
    },
    buttons: [
      {
        text: "Next",
        action: () => {
          const elem = document.getElementsByClassName(
            "wheel-feeling-arc love"
          )[0];
          const clickEvent = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: true,
          });
          if (elem) elem.dispatchEvent(clickEvent);
          tour.next();
        },
      },
    ],
  });
  tour.addStep({
    id: "step-2",
    text: "Choose a song to start listening",
    classes: "text-center",
    useModalOverlay: false,
    modalOverlayOpeningPadding: 0,
    modalOverlayOpeningRadius: 0,
    attachTo: {
      element: ".tracks-list .card",
      on: "left",
    },
    buttons: [{ text: "Next", action: tour.next }],
  });
  tour.addStep({
    id: "step-3",
    text: "Click the eject button to go back to the previous level",
    classes: "text-center",
    modalOverlayOpeningPadding: 10,
    modalOverlayOpeningRadius: 10,
    attachTo: {
      element: "#feelings_wheel_back",
      on: "bottom",
    },
    buttons: [
      {
        text: "End",
        action: () => {
          const elem = document.getElementById("wheel_background");
          const clickEvent = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: true,
          });
          if (elem) elem.dispatchEvent(clickEvent);
          tour.next();
        },
      },
    ],
  });
  tour.start();
};

onMounted(() => {
  if (currentTourVersion > tourVersionSeen.value) startTour();
});
</script>

<style>
.shepherd-element[data-popper-placement^="left"] > .shepherd-arrow {
  /* Fix arrow position bug */
  right: 0;
}
</style>
